import { type SearchValues, useAssignQueryParameter, useUpdateQueryParams, useWithDefault } from '@pba/react-router';
import { useCallback, useMemo } from 'react';
import type { SettingsParams, SettingsScope } from 'features/settings';
import { ScopeParameter } from './scope-parameter';

type P = {
  defaultScope?: SettingsScope;
  scopeKey?: string;
};

export const useSettingsTabsParams = ({
  defaultScope = 'notifications',
  scopeKey = 'scope',
}: P = {}): SettingsParams => {
  const updateQueryParams = useUpdateQueryParams();
  const { assignValue: setScope, value: scope } = useAssignQueryParameter(
    scopeKey,
    useWithDefault<SettingsScope>(ScopeParameter, defaultScope),
  );

  const onChangeTab = useCallback(
    (tab: SettingsScope) => {
      const urlUpdates: SearchValues = {};
      setScope({ newValue: tab, object: urlUpdates });
      updateQueryParams({ keepPreviousParams: false, urlUpdates });
    },
    [setScope, updateQueryParams],
  );

  return useMemo(
    () => ({
      onChangeTab,
      tab: scope,
    }),
    [scope, onChangeTab],
  );
};
